import './styles.css';

const Footer = () => {

	return (
		<footer className="Footer">

			Built by Behind The Dot

		</footer>
	)
}

export default Footer;